module.exports = __webpack_public_path__ + "static/media/avatar.26ff44a2.png";